module.exports = __webpack_public_path__ + "static/media/ic-mob-trust.6b2490cb.svg";